import React from 'react';

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';

import CohortManagent from '../components/Cohort/CohortManagent';
import DemoPage from '../components/Demo/DemoPage';
import Favorites from '../components/Favorites/Favorites';
import Home from '../components/Home/Home';
import Lab from '../components/Lab/Lab';
import SignIn from '../components/Login/SignIn';

import NewSignIn from '../components/Login/NewSignIn';
import SignUp from '../components/Login/SignUp';
import AddBanner from '../components/Notifications/banners/AddBanner';
import BannersArchive from '../components/Notifications/banners/BannersArchive';
import NotificationsDashboard from '../components/Notifications/NotificationsDashboard';
import { AccountLocked } from '../components/Password/AccountLocked';
import ResetPassword from '../components/Password/ResetPassword';
import ResetPasswordConfirm from '../components/Password/ResetPasswordConfirm';
import RecentlyViewd from '../components/RecentlyViewed/RecentlyViewd';
import Reports from '../components/Reports/Reports';
import Settings from '../components/Settings/Settings';
import AddUser from '../components/Users/AddUser/AddUser';
import EditUser from '../components/Users/AddUser/EditUser';
import UserDetails from '../components/Users/UserDetails';
import UsersList from '../components/Users/UsersList';
import RootRoute from './RootRouter';
import PRoute from './PRoute';

const Routing = () => (
  <Router basename='/analytics/ui'>
    {/* <Routes>
      <Route path='/' element={RootRoute} />
    </Routes> */}
    <Routes>
      <Route path='/login' element={<SignIn />} linkName='signin' />
      <Route path='/signup' element={<SignUp />} linkName='signup' />
      <Route path='/ssologin' element={<NewSignIn />} linkName='ssologin' />
      <Route path='/forgotPassword' element={<ResetPassword />} linkName='forgotPassword' />
      <Route path='/resetpassword' element={<ResetPasswordConfirm />} linkName='resetPassword' />
      <Route path='/accountLocked' element={<AccountLocked />} linkName='accountLocked' />
      <Route
        path='/__demo'
        element={
          <PRoute linkName='__demo'>
            <DemoPage />
          </PRoute>
        }
      />
      <Route path='/users'
        element={
          <PRoute path='/users' linkName='users' >
            <RootRoute />
            <UsersList />
          </PRoute>}
      />
      {/****************************/}

      <Route path='/userDetails'
        element={
          <PRoute path='/userDetails' linkName='userDetails' >
            <UserDetails />
          </PRoute>}
      />
      <Route path='/addBanner'
        element={
          <PRoute path='/addBanner' linkName='addBanner' >
            <AddBanner />
          </PRoute>}
      />
      <Route path='/addBanner/:id'
        element={
          <PRoute path='/addBanner/:id' linkName='addBanner' >
            <AddBanner />
          </PRoute>}
      />
      <Route path='/bannersArchive'
        element={
          <PRoute path='/bannersArchive' linkName='bannersArchive' >
            <BannersArchive />
          </PRoute>}
      />
      <Route path='/messageUsers'
        element={
          <PRoute path='/messageUsers' linkName='messageUsers' >
            <NotificationsDashboard />
          </PRoute>}
      />
      <Route path='/messageUsers/:id'
        element={
          <PRoute path='/messageUsers/:id' linkName='messageUsers' >
            <NotificationsDashboard />
          </PRoute>}
      />
      <Route path='/manageCohort'
        element={
          <PRoute path='/manageCohort' linkName='cohortManagement' >
            <CohortManagent />
          </PRoute>}
      />
      <Route path='/editUser'
        element={
          <PRoute path='/editUser' linkName='editUser' >
            <EditUser />
          </PRoute>}
      />
      <Route path='/addUser'
        element={
          <PRoute path='/addUser' linkName='addUser' >
            <AddUser />
          </PRoute>}
      />
      <Route path='/settings'
        element={
          <PRoute path='/settings' linkName='settings' >
            <Settings />
          </PRoute>}
      />
      <Route path='/reports'
        element={
          <PRoute path='/reports' linkName='reports' >
            <Reports />
          </PRoute>}
      />
      <Route path='/lab'
        element={
          <PRoute path='/lab' linkName='lab' >
            <Lab />
          </PRoute>}
      />
      <Route path='/recentlyViewd'
        element={
          <PRoute path='/recentlyViewd' linkName='recentlyViewd' >
            <RecentlyViewd />
          </PRoute>}
      />
      <Route path='/favorites'
        element={
          <PRoute path='/favorites' linkName='favorites' >
            <Favorites />
          </PRoute>}
      />

      <Route path='/'
        element={
          <PRoute path='/' linkName='home' >
            <RootRoute />
            <Home />
          </PRoute>}
      />

    </Routes>
  </Router>
)

export default Routing
